import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';

import { AddedProductResponsiveItemFundsProps } from '.';

export const AddedProductItemFundsTablet: React.FC<AddedProductResponsiveItemFundsProps> = ({
  data,
  inputMoneyDataProps,
  minimumMovimentationFormatted,
  onRemoveProduct,
}) => {
  return (
    <VStack w={'full'}>
      <HStack justifyContent="space-between" w="full" space={Spacing['inline.quarck']}>
        <TableContentItemColumn flex={2} space={Spacing['inline.quarck']}>
          <TableContentItemText noOfLines={2}>{data.productDisplay}</TableContentItemText>
          <TableContentItemCaptions forceDesktop icons={data.captions || []} />
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText>Tipo</TableContentItemText>
          <TableContentItemText>{data.productCategory}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText>Rent. 12 meses</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.Percentage(data.profitabilityTwelveMonthsAdjusted)}
          </TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText>Taxa Admin.</TableContentItemText>
          <TableContentItemText>{data.administrationFee}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.nano']}>
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={data.riskRatingLevel || 0}
            tooltip={data.riskRating || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn maxW="50px" space={Spacing['inline.quarck']}>
          <TableContentItemText>Resgate</TableContentItemText>
          <TableContentItemText>{data.quotationRedemptionTermFormatted}</TableContentItemText>
        </TableContentItemColumn>
      </HStack>
      <HStack w="full" space={Spacing['inline.xxxs']}>
        <TableContentItemColumn maxW="100px" space={Spacing['inline.quarck']}>
          <TableContentItemText>Aplicação mín.</TableContentItemText>
          <TableContentItemText>{minimumMovimentationFormatted}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn>
          <TableContentItemText>Valor a aplicar</TableContentItemText>
          <HStack alignItems="center" space={Spacing['inline.quarck']}>
            <InputMoney {...inputMoneyDataProps} />
            <IconButton
              testId="icon-button"
              onPress={onRemoveProduct}
              borderRadius={BoxRadius.sm}
              icon="Trash"
              p={0}
              iconColor={Color['feedback.error.default']}
              iconSize="xs"
            />
          </HStack>
        </TableContentItemColumn>
      </HStack>
    </VStack>
  );
};
